module.exports = __webpack_public_path__ + "assets/img/customers4.5d6eface.png";